// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"53242857","527":"af27f05d","787":"f21807dd","868":"62b0192a","937":"4de3f23c"}[chunkId] + ".chunk.js";
};